import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove the injected platform badge as soon as it appears in the DOM
const observer = new MutationObserver(() => {
  const badge = document.getElementById("emergent-badge");
  if (badge) badge.remove();
});
observer.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
